export default __webpack_public_path__ + "static/media/picture.07e752ae.svg";